import React from "react";

class ToolTipPopup extends React.Component {

  hideToggle = (e) => {
    this.props.togglePopupWindow(false, e);
  };

  render() {
    return (
      <div className={`modal unhappy-customer show tooltip-model`}>
        <div className="modal-dialog">
          <div className="modal-content display-block-popup">
            <div className="modal-header">
              <div className="container">
                <div className="d-flex flex-row-reverse">
                  <div className="p-0 window-btn-right">
                    <h3 className="header-font standard-blue text-right window-btn mr20"
                      onClick={this.hideToggle} tabIndex="0"
                      onKeyDown={e=> {
                        let key = e.keyCode;
                        key === 13 ? this.hideToggle(e) : null;
                        key === 32 ? this.hideToggle(e) : null;
                      }}>&times;</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6 form-group p-r-7">
                  <div className="standard-blue font-size-20">003765892</div>
                  <div className="font-size-14 font-weight-400">Routing number</div>
                </div>
                <div className="col-6 form-group p-r-7 p-l-7">
                  <div className="standard-blue font-size-20">12378923455</div>
                  <div className="font-size-14 font-weight-400">Account number</div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h4 className="helpfull-hint">
                    Helpful hint
                  </h4>
                  <p className="font-size-14 font-weight-400 your-loan-light-grey padding-top-5">Routing and Account numbers are typically found in the bottom,
                    left-hand corner of most personal checks.</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ToolTipPopup;
